import { StoredCreditCodeStatusZodSchema } from "@redotech/redo-return-core-common/return";
import * as z from "zod";

/** What the activity feed fetches from the commerce platform: exchange orders, the draft order and stored-credit codes. */
export const getReturnPlatformActivity = {
  name: "getReturnPlatformActivity" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    exchanges: z.array(z.any()),
    draftOrder: z.any().nullable(),
    storedCreditCodes: z.array(
      z.object({
        discountCodeId: z.string(),
        code: z.string().optional(),
        codeStatus: StoredCreditCodeStatusZodSchema,
      }),
    ),
  }),
};
